import { icon } from "@fortawesome/fontawesome-svg-core";
import {
  faBook,
  faBusinessTime,
  faCar,
  faHouse,
  faMoneyBill1Wave,
  faPerson,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

// LoanCard Component
const Card = ({ icon, title, desc, index, type, loanType }) => (
  <div
    key={index}
    className={`bg-white ${
      type == loanType ? "block" : "hidden"
    } shadow-lg rounded-lg p-6 w-full lg:w-96 transform hover:scale-105 transition-all mb-4`}
  >
    <div className="flex items-center space-x-4">
      <FontAwesomeIcon
        icon={icon}
        className="text-red-600 w-12 h-12 hover:text-red-800"
      />
    </div>
    <h3 className="text-xl font-bold text-gray-800 mt-4">{title}</h3>
    <p className="text-gray-600 mt-2">{desc}</p>
  </div>
);

// LoanPage Component
const LoanPage = () => {
  const [loanType, setLoanType] = useState("loans");
  // Loan Data Array
  const loanOptions = [
    {
      type: "loans",
      title: "Home Loans",
      description:
        "Fulfill your dream of owning a home with our affordable home loan options, featuring competitive interest rates and flexible terms.",
      icon: faHouse,
    },
    {
      type: "loans",
      title: "Personal Loans",
      description:
        "Get quick and hassle-free personal loans to meet your immediate financial needs with minimal documentation.",
      icon: faPerson,
    },
    {
      type: "loans",
      title: "Business Loans",
      description:
        "Scale your business with customized business loans, designed to support your growth and expansion plans.",
      icon: faBusinessTime,
    },
    {
      type: "loans",
      title: "Car Loans",
      description:
        "Drive your dream car with our easy car loan options, offering fast approvals and low EMIs.",
      icon: faCar,
    },
    {
      type: "loans",
      title: "Education Loans",
      description:
        "Invest in your future with our education loans, offering financial assistance for higher studies in India and abroad.",
      icon: faBook,
    },
    {
      type: "loans",
      title: "Utility Vehicle Loan",
      description:
        "A Utility Vehicle Loan helps finance the purchase of vehicles for commercial, agricultural, or multi-purpose use with flexible repayment options.",
      icon: faMoneyBill1Wave,
    },
    {
      type: "loans",
      title: "Commercial Vehicle Loan",
      description:
        "A Commercial Vehicle Loan finances new or used vehicles for business purposes, offering competitive rates, flexible tenures, and easy eligibility.",
      icon: faMoneyBill1Wave,
    },
    {
      type: "SMEloans",
      title: "Loan Against Property",
      description:
        "A Loan Against Property allows individuals or businesses to borrow money by pledging their property as collateral for financial needs.",
      icon: faMoneyBill1Wave,
    },
    {
      type: "SMEloans",
      title: "Machinery Loan",
      description:
        "A Machinery Loan helps businesses finance the purchase of new or used machinery, with flexible repayment options and competitive interest rates.",
      icon: faMoneyBill1Wave,
    },
    {
      type: "SMEloans",
      title: "Auction Notices",
      description:
        "Auction Notices are formal announcements informing the public about upcoming auctions, detailing items for sale, auction dates, and terms.",
      icon: faMoneyBill1Wave,
    },
    {
      type: "SMEloans",
      title: "Projects Loan",
      description:
        "A Project Loan finances the development of specific projects, offering funding for construction, infrastructure, or business expansion.",
      icon: faMoneyBill1Wave,
    },
    {
      type: "SMEloans",
      title: "Mudra Loan",
      description:
        "Mudra Loan provides financial support to micro, small, and medium businesses in India for starting or growing their ventures.",
      icon: faMoneyBill1Wave,
    },
    {
      type: "SMEloans",
      title: "Loan Npa Solution",
      description:
        "Loan NPA Solution offers strategies to resolve non-performing asset issues, helping banks and borrowers manage overdue loans effectively.",
      icon: faMoneyBill1Wave,
    },
  ];

  return (
    <div className="bg-gray-50 text-gray-800 min-h-screen">
      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 space-y-12">
        {/* Available Loans Section */}
        <section>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center py-10">
            Diversified Loan Options
          </h2>

          <div className="flex gap-4 my-10">
            <button
              onClick={() => setLoanType("loans")}
              className="bg-red-600 text-white hover:bg-white hover:text-red-600 transition-all font-bold py-3 px-6"
            >
              Loans
            </button>
            <button
              onClick={() => setLoanType("SMEloans")}
              className="bg-red-600 text-white hover:bg-white hover:text-red-600 transition-all font-bold py-3 px-6"
            >
              SME Loans
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {loanOptions.map((loan, index) => (
              <Card
                key={index}
                type={loan.type}
                icon={loan.icon}
                loanType={loanType}
                title={loan.title}
                desc={loan.description}
              />
            ))}
          </div>
        </section>

        {/* Call-to-Action Section */}
        <section className="bg-red-500 text-white rounded-lg shadow-md p-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Apply?</h2>
          <p className="text-lg leading-relaxed mb-6">
            Apply for a loan today and take the first step towards achieving
            your goals. Our team is here to guide you through every step of the
            process.
          </p>
          <a
            href="https://wa.me/+917566611125/?text=Hello Kalka Capital"
            className="text-white decoration-none"
          >
            <button className="bg-white text-red-500 px-6 py-3 rounded-lg font-semibold shadow-md hover:bg-gray-200 transition">
              Apply Now
            </button>
          </a>
        </section>
      </main>
    </div>
  );
};

export default LoanPage;
